export type SongRequestStatus = 'pendiente' | 'aceptada' | 'atendida' | 'reproducida' | 'rechazada' | 'cancelada' | 'expirada';

export interface SongRequest {
  id: number;
  songName: string;
  artistName: string;
  requesterName: string;
  requesterAvatar: string;
  requesterLocation: string;
  requestedAt: string;
  status: SongRequestStatus;
  dedication?: string;
  greeting?: string;
  acceptedAt?: string;
  attendedAt?: string;
  playedAt?: string;
  rejectedAt?: string;
  cancelledAt?: string;
  rejectionReason?: string;
  operatorResponse?: string;
}

export interface TopSong {
  songName: string;
  artistName: string;
  requestCount: number;
}

export const topSongs: TopSong[] = [
  { songName: 'Vivir Mi Vida', artistName: 'Marc Anthony', requestCount: 47 },
  { songName: 'Bailando', artistName: 'Enrique Iglesias', requestCount: 38 },
  { songName: 'Despacito', artistName: 'Luis Fonsi ft. Daddy Yankee', requestCount: 35 },
  { songName: 'A Puro Dolor', artistName: 'Sin Bandera', requestCount: 31 },
  { songName: 'La Bicicleta', artistName: 'Carlos Vives & Shakira', requestCount: 28 },
  { songName: 'Hawái', artistName: 'Maluma', requestCount: 26 },
  { songName: 'El Favor', artistName: 'Paty Cantú', requestCount: 24 },
  { songName: 'Me Rehúso', artistName: 'Danny Ocean', requestCount: 23 },
  { songName: 'Tusa', artistName: 'Karol G & Nicki Minaj', requestCount: 21 },
  { songName: 'Robarte un Beso', artistName: 'Carlos Vives & Sebastián Yatra', requestCount: 20 },
];

export const songRequests: SongRequest[] = [
  {
    id: 1,
    songName: 'Vivir Mi Vida',
    artistName: 'Marc Anthony',
    requesterName: 'Carlos Ramírez',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-song-carlos&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-15T14:25:00',
    status: 'pendiente',
    dedication: 'Para todos los que están pasando por un mal momento, ¡la vida es una sola y hay que vivirla!',
    greeting: 'Un abrazo enorme a toda la gente de San José que nos escucha.',
  },
  {
    id: 2,
    songName: 'Hawái',
    artistName: 'Maluma',
    requesterName: 'Sofía Hernández',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-sofia&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-15T14:20:00',
    status: 'pendiente',
  },
  {
    id: 3,
    songName: 'Despacito',
    artistName: 'Luis Fonsi ft. Daddy Yankee',
    requesterName: 'Pedro Gutiérrez',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-song-pedro&orientation=squarish',
    requesterLocation: 'Alajuela',
    requestedAt: '2026-07-15T14:15:00',
    status: 'pendiente',
    dedication: 'Dedicada a mi esposa Laura, 25 años juntos y contando. ¡Te amo!',
  },
  {
    id: 4,
    songName: 'La Bicicleta',
    artistName: 'Carlos Vives & Shakira',
    requesterName: 'Valentina Castro',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-valentina&orientation=squarish',
    requesterLocation: 'Heredia',
    requestedAt: '2026-07-15T14:10:00',
    status: 'pendiente',
    dedication: 'Para Diego y Natalia, que ponen la mejor música mientras pinto.',
  },
  {
    id: 5,
    songName: '',
    artistName: '',
    requesterName: 'Roberto Sánchez',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20style%2C%20friendly%20expression%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=admin-song-roberto&orientation=squarish',
    requesterLocation: 'Cartago',
    requestedAt: '2026-07-15T14:05:00',
    status: 'pendiente',
    greeting: 'Buenas tardes a todo el equipo de la radio. Hoy cumplo un año escuchándolos y quería mandarles un saludo enorme. ¡Son los mejores!',
  },
  {
    id: 6,
    songName: 'Bailando',
    artistName: 'Enrique Iglesias',
    requesterName: 'Ana Patricia Vega',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20woman%2C%20elegant%20casual%20style%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-ana-patricia&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-15T13:50:00',
    status: 'pendiente',
    dedication: '10 años escuchándolos, esta canción me recuerda mis inicios. ¡Gracias por todo!',
  },
  {
    id: 7,
    songName: 'Me Rehúso',
    artistName: 'Danny Ocean',
    requesterName: 'Diego Vargas',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=admin-song-diego&orientation=squarish',
    requesterLocation: 'Alajuela',
    requestedAt: '2026-07-15T13:30:00',
    status: 'aceptada',
    acceptedAt: '2026-07-15T13:40:00',
  },
  {
    id: 8,
    songName: 'Tusa',
    artistName: 'Karol G & Nicki Minaj',
    requesterName: 'Camila Soto',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20modern%20trendy%20style%2C%20bright%20genuine%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=admin-song-camila&orientation=squarish',
    requesterLocation: 'Cartago',
    requestedAt: '2026-07-15T13:15:00',
    status: 'aceptada',
    acceptedAt: '2026-07-15T13:20:00',
  },
  {
    id: 9,
    songName: 'El Favor',
    artistName: 'Paty Cantú',
    requesterName: 'Natalia Campos',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20in%20her%2030s%2C%20warm%20friendly%20smile%2C%20casual%20chic%20style%2C%20soft%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=admin-song-natalia&orientation=squarish',
    requesterLocation: 'Alajuela',
    requestedAt: '2026-07-15T12:45:00',
    status: 'aceptada',
    acceptedAt: '2026-07-15T12:50:00',
    dedication: 'Para mi mejor amiga que está pasando por una ruptura. ¡Arriba amiga, tú puedes!',
  },
  {
    id: 10,
    songName: 'Robarte un Beso',
    artistName: 'Carlos Vives & Sebastián Yatra',
    requesterName: 'Javier Núñez',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20trendy%20street%20style%2C%20charismatic%20smile%2C%20urban%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=admin-song-javier&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-15T12:30:00',
    status: 'atendida',
    acceptedAt: '2026-07-15T12:35:00',
    attendedAt: '2026-07-15T12:42:00',
    operatorResponse: '¡Gracias Javier! Ahí va tu canción, un abrazo.',
  },
  {
    id: 11,
    songName: 'Vivir Mi Vida',
    artistName: 'Marc Anthony',
    requesterName: 'Lucía Mendoza',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%2C%20natural%20makeup%2C%20casual%20look%2C%20soft%20natural%20light%2C%20clean%20bright%20background&width=80&height=80&seq=admin-song-lucia&orientation=squarish',
    requesterLocation: 'Heredia',
    requestedAt: '2026-07-15T11:50:00',
    status: 'reproducida',
    acceptedAt: '2026-07-15T11:55:00',
    attendedAt: '2026-07-15T12:00:00',
    playedAt: '2026-07-15T12:05:00',
    dedication: 'Para mi abuelita que ya salió del hospital. ¡Bienvenida a casa abue!',
  },
  {
    id: 12,
    songName: 'Bailando',
    artistName: 'Enrique Iglesias',
    requesterName: 'Daniela Quirós',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%2C%20sporty%20casual%20look%2C%20energetic%20smile%2C%20bright%20natural%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-daniela&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-15T11:20:00',
    status: 'reproducida',
    acceptedAt: '2026-07-15T11:25:00',
    attendedAt: '2026-07-15T11:30:00',
    playedAt: '2026-07-15T11:35:00',
  },
  {
    id: 13,
    songName: 'Despacito',
    artistName: 'Luis Fonsi ft. Daddy Yankee',
    requesterName: 'Eduardo Paredes',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20professional%20style%2C%20friendly%20but%20serious%20expression%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=admin-song-eduardo&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-15T10:45:00',
    status: 'reproducida',
    acceptedAt: '2026-07-15T10:50:00',
    attendedAt: '2026-07-15T10:55:00',
    playedAt: '2026-07-15T11:00:00',
  },
  {
    id: 14,
    songName: '',
    artistName: '',
    requesterName: 'Tomás Blanco',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20European%20Latino%20mixed%20man%2C%20creative%20style%2C%20thoughtful%20expression%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-tomas&orientation=squarish',
    requesterLocation: 'Alajuela',
    requestedAt: '2026-07-15T10:10:00',
    status: 'rechazada',
    rejectedAt: '2026-07-15T10:15:00',
    rejectionReason: 'El mensaje contiene lenguaje inapropiado para el horario.',
    greeting: 'Saludos a todos...',
  },
  {
    id: 15,
    songName: 'Tusa',
    artistName: 'Karol G & Nicki Minaj',
    requesterName: 'Andrea Torres',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20bright%20smile%2C%20everyday%20casual%20look%2C%20soft%20daylight%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20light%20background&width=80&height=80&seq=admin-song-andrea&orientation=squarish',
    requesterLocation: 'Cartago',
    requestedAt: '2026-07-15T09:30:00',
    status: 'rechazada',
    rejectedAt: '2026-07-15T09:35:00',
    rejectionReason: 'Contenido explícito — fuera de la política de la emisora en este horario.',
  },
  {
    id: 16,
    songName: 'El Favor',
    artistName: 'Paty Cantú',
    requesterName: 'Francisco Jiménez',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%2C%20kind%20weathered%20face%2C%20simple%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-song-francisco&orientation=squarish',
    requesterLocation: 'Heredia',
    requestedAt: '2026-07-15T08:45:00',
    status: 'rechazada',
    rejectedAt: '2026-07-15T08:50:00',
    rejectionReason: 'Solicitud duplicada — el oyente ya tiene una canción pendiente en la cola.',
  },
  {
    id: 17,
    songName: '',
    artistName: '',
    requesterName: 'María Fernanda López',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20light%20background&width=80&height=80&seq=admin-song-maria-fer&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-14T18:30:00',
    status: 'atendida',
    acceptedAt: '2026-07-14T18:35:00',
    attendedAt: '2026-07-14T18:50:00',
    greeting: 'Buenas noches! Quiero mandar un abrazo enorme a mi mamá en su cumpleaños. ¡Te quiero mucho!',
    operatorResponse: '¡Feliz cumpleaños a tu mamá, María Fernanda! Un abrazo enorme para las dos.',
  },
  {
    id: 18,
    songName: 'A Puro Dolor',
    artistName: 'Sin Bandera',
    requesterName: 'Gabriela Mora',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20professional%20Latina%20woman%2C%20business%20casual%2C%20confident%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-gabriela&orientation=squarish',
    requesterLocation: 'Limón',
    requestedAt: '2026-07-14T17:00:00',
    status: 'reproducida',
    acceptedAt: '2026-07-14T17:05:00',
    attendedAt: '2026-07-14T17:15:00',
    playedAt: '2026-07-14T17:20:00',
  },
  {
    id: 19,
    songName: 'La Bicicleta',
    artistName: 'Carlos Vives & Shakira',
    requesterName: 'Carlos Ramírez',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=admin-song-carlos-2&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-14T15:45:00',
    status: 'aceptada',
    acceptedAt: '2026-07-14T15:50:00',
    dedication: 'Para el equipo de fútbol del barrio. ¡Campeones!',
  },
  {
    id: 20,
    songName: 'Hawái',
    artistName: 'Maluma',
    requesterName: 'Sofía Hernández',
    requesterAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=admin-song-sofia-2&orientation=squarish',
    requesterLocation: 'San José',
    requestedAt: '2026-07-14T14:30:00',
    status: 'rechazada',
    rejectedAt: '2026-07-14T14:35:00',
    rejectionReason: 'Canción solicitada más de 3 veces en el mismo día — límite diario alcanzado.',
  },
];

export const statusLabels: Record<SongRequestStatus, string> = {
  pendiente: 'Pendiente',
  aceptada: 'Aceptada',
  atendida: 'Atendida',
  reproducida: 'Transmitida',
  rechazada: 'Rechazada',
  cancelada: 'Cancelada',
  expirada: 'Expirada',
};

export const statusColors: Record<SongRequestStatus, { dot: string; bg: string; text: string; icon: string }> = {
  pendiente: { dot: 'bg-amber-500', bg: 'bg-amber-50 border-amber-200', text: 'text-amber-700', icon: 'ri-time-line' },
  aceptada: { dot: 'bg-primary-500', bg: 'bg-primary-50 border-primary-200', text: 'text-primary-700', icon: 'ri-check-line' },
  atendida: { dot: 'bg-sky-500', bg: 'bg-sky-50 border-sky-200', text: 'text-sky-700', icon: 'ri-broadcast-line' },
  reproducida: { dot: 'bg-emerald-500', bg: 'bg-emerald-50 border-emerald-200', text: 'text-emerald-700', icon: 'ri-check-double-fill' },
  rechazada: { dot: 'bg-rose-500', bg: 'bg-rose-50/70 border-rose-200', text: 'text-rose-700', icon: 'ri-close-circle-fill' },
  cancelada: { dot: 'bg-foreground-400', bg: 'bg-foreground-50 border-foreground-200', text: 'text-foreground-600', icon: 'ri-close-line' },
  expirada: { dot: 'bg-foreground-300', bg: 'bg-foreground-50 border-foreground-200', text: 'text-foreground-500', icon: 'ri-timer-line' },
};